import actions from './actions'

const initialState = {
  list: [], // All permissions
  selected: null, // Currently selected permission
  loading: false,
  error: null,
}

export default function permissionsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case actions.FETCH_PERMISSIONS_RECEIVED:
      return {
        ...state,
        list: action.payload || [],
        loading: false,
      }

    case actions.FETCH_PERMISSION_RECEIVED:
      return {
        ...state,
        selected: action.payload,
        loading: false,
      }

    case actions.RESPONSE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}
